import { PAGE_LEVEL_NAVIGATION_DEFAULT_HEIGHT } from '@yme/components/Header/PageLevelNavigation';
import { getSelectYourModelModalLabels } from '@yme/modals/SelectYourModelModal';
import { setIsModalShowed } from '@yme/modals/actions';
import { MODALS } from '@yme/modals/constants';
import { DigitalDataMutation, isPDFlink, setDigitalData } from '@yme/utils/common';
import { DEFAULT_PRODUCT_CARD_MARGIN_TOP_MOBILE, DEFAULT_PRODUCT_CARD__MARGIN_TOP_TABLET, DEFAULT_PRODUCT_CARD__MARGIN_TOP_DESKTOP, } from '../constants';
import { setSelectedCompatibilityProduct } from '../redux';
export const getDownloadSectionItems = ({ variant, name, }) => {
    if (!variant) {
        return [];
    }
    return variant.images
        .filter((item) => isPDFlink(item.url))
        .map((item) => {
        return {
            filePath: item.url,
            type: 'application/pdf',
            name,
        };
    });
};
export const getKeysQueryParamString = (keys) => keys.reduce((result, key, index) => {
    if (index === 0) {
        return `${result}${key}`;
    }
    return `${result}${encodeURIComponent(`|${key}`)}`;
}, '');
export const getSuitableRequiredItems = (requiredItems, accessories) => requiredItems.filter((item) => accessories.includes(item));
export const setSelectedUnit = (key, suitableProductsKeys, product, dispatch, isUserAction = false) => {
    if (key && suitableProductsKeys) {
        const isSuccessCheck = suitableProductsKeys?.length
            ? suitableProductsKeys.some((productKey) => Number(productKey) === Number(key))
            : false;
        dispatch(setSelectedCompatibilityProduct({
            isSuccessCheck,
            product,
            isUserAction,
        }));
    }
};
export const openSelectModelModal = ({ dispatch, labels, commonLabels, endpoints, defaultStartYear, categories, callback, }) => {
    const modalLabels = getSelectYourModelModalLabels(labels);
    setDigitalData(DigitalDataMutation.COMPATIBILITY_CLICK, null);
    dispatch(setIsModalShowed({
        type: MODALS.SELECT_YOUR_MODEL_MODAL,
        data: {
            title: modalLabels.header,
            endpoints,
            defaultStartYear,
            categories,
            callback,
            labels: modalLabels,
            primaryButtonContent: commonLabels?.common_confirm_button,
            secondaryButtonContent: commonLabels?.common_cancel_button,
            isPDP: true,
        },
    }));
};
export const getMarginTop = (isPlpDataExisted) => {
    const defaultMarginTop = {
        mobileMargin: `${DEFAULT_PRODUCT_CARD_MARGIN_TOP_MOBILE}px`,
        tabletMargin: `${DEFAULT_PRODUCT_CARD__MARGIN_TOP_TABLET}px`,
        desktopMargin: `${DEFAULT_PRODUCT_CARD__MARGIN_TOP_DESKTOP}px`,
    };
    if (isPlpDataExisted) {
        return {
            mobileMargin: `${DEFAULT_PRODUCT_CARD_MARGIN_TOP_MOBILE + PAGE_LEVEL_NAVIGATION_DEFAULT_HEIGHT.mobile}px`,
            tabletMargin: `${DEFAULT_PRODUCT_CARD__MARGIN_TOP_TABLET + PAGE_LEVEL_NAVIGATION_DEFAULT_HEIGHT.tablet}px`,
            desktopMargin: `${DEFAULT_PRODUCT_CARD__MARGIN_TOP_DESKTOP + PAGE_LEVEL_NAVIGATION_DEFAULT_HEIGHT.tablet}px`,
        };
    }
    return defaultMarginTop;
};
